var map = {
	"./cs.json": 34415,
	"./da.json": 96829,
	"./de.json": 21629,
	"./en-GB.json": 82704,
	"./en.json": 28027,
	"./es.json": 98185,
	"./fr-CA.json": 49845,
	"./fr.json": 31702,
	"./it.json": 11340,
	"./ja.json": 53935,
	"./ko.json": 38540,
	"./nl.json": 85323,
	"./no.json": 97580,
	"./pl.json": 57872,
	"./pt-BR.json": 12777,
	"./ru.json": 65537,
	"./sv.json": 98656,
	"./zh-Hans.json": 675,
	"./zh-Hant.json": 61021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70879;